<template lang="pug">
.field.is-grouped
  .control
    router-link.button(:to="links.edition") {{ $t('edition') }}
  .control
    router-link.button(:to="links.archive") {{ $t('archiv') }}
  .control
    router-link.button(:to="links.projects") {{ $t('projekte_kurz') }}
  .control(v-if="withsearchresults")
    router-link.button(:to="links.search") {{ $t('searchResults') }}
  .control(v-if="withsearchresults")
    router-link.button(:to="links.watchlist") {{ $t('watchlist') }}
</template>

<script>
const { toc, toRoute } = require("../toc");

export default {
    name: "SectionSwitch",
    props: ["withsearchresults"],
    computed: {
        links: function() {
            const currentRoute = this.$route.name;
            const sections = ["edition", "archive", "projects", "translations"].reduce(
                (links, section) => ({
                    ...links,
                    [section]: toRoute({ name: currentRoute, section, id: this.$route.params.id || toc.first(section).id })
                }), "");

            if (this.withsearchresults) {
                sections["search"] = toRoute({ name: currentRoute, section: "search", id: this.$route.params.id })
                sections["watchlist"] = toRoute({ name: currentRoute, section: "watchlist", id: this.$route.params.id })
            }

            return sections
        }
    }
}
</script>